// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".about-us[data-v-f6fa8ef2] .button-grey{background:#0298fa;color:#fff}.about-us[data-v-f6fa8ef2] .button-grey:hover{background:#0071ba;color:#fff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
